import React from 'react';

interface ProcessStepProps {
  number: string;
  title: string;
  description: string;
  delay: string;
}

const ProcessStep = ({ number, title, description, delay }: ProcessStepProps) => {
  return (
    <div
      className="glass-card hover-lift p-8 text-center animate-fade-in-up opacity-0"
      style={{ animationDelay: delay }}
    >
      <div className="w-16 h-16 rounded-full bg-primary/10 border border-primary/30 flex items-center justify-center mb-5 mx-auto">
        <span className="font-display text-2xl font-bold text-primary">{number}</span>
      </div>
      <h3 className="font-display text-xl font-bold mb-3 text-foreground">{title}</h3>
      <p className="text-muted-foreground">{description}</p>
    </div>
  );
};

export default ProcessStep;
